import React, { useEffect, useState } from 'react';
import { InputAdornment } from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { faFileDownload, faFileCsv } from '@fortawesome/pro-light-svg-icons';
import {
    ActionIconButton, ColumnFilter, RowFilter, SearchBar,
} from '../..';

import './DataviewTableHeader.scss';

/**
 * @param {{
 *  onSearch?: (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>, value: string) => void;
 *  rowFilterProps?: *;
 *  downloadExcelProps?: import('typings').DownloadExcelProps | undefined;
 *  downloadCSVProps?: import('typings').DownloadCSVProps | undefined;
 *  columnFilterProps?: *;
 * }} param0
 */
const FormDataviewHeader = ({
    onSearch,
    rowFilterProps,
    downloadExcelProps,
    downloadCSVProps,
    columnFilterProps,
}) => {
    const { t } = useTranslation('table', { keyPrefix: 'actions' });
    const [search, setSearch] = useState('');

    // Reset the search value on destroy
    useEffect(() => () => {
        if (onSearch) {
            setSearch('');
        }
    }, []);

    return (
        <div className="core--table-dataview-header">
            <div className="core--table-dataview-header-left">
                <div className={`core--search-container ${!(onSearch) ? 'hide-search' : ''}`}>
                    {
                        !!onSearch && (
                            <SearchBar
                                id="react-search-input"
                                placeholder={t('searchPlaceholder')}
                                size="small"
                                variant="outlined"
                                value={search}
                                onChange={(event) => {
                                    const value = event?.target?.value;
                                    setSearch(value);
                                    onSearch(event, value);
                                }}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchIcon />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        )
                    }
                </div>
                {
                    !!rowFilterProps && (
                        <RowFilter {...rowFilterProps} />
                    )
                }
            </div>
            <div className="core--table-dataview-header-right">
                {
                    !!downloadExcelProps && (
                        <ActionIconButton
                            icon={faFileDownload}
                            title={t('downloadExcel')}
                            onClick={downloadExcelProps.onClick}
                            disabled={downloadExcelProps.disabled}
                        />
                    )
                }
                                {
                    !!downloadCSVProps && (
                        <ActionIconButton
                            icon={faFileCsv}
                            title={t('downloadCSV')}
                            onClick={downloadCSVProps.onClick}
                            disabled={downloadCSVProps.disabled}
                        />
                    )
                }
                <ColumnFilter {...columnFilterProps} />
            </div>
        </div>
    );
};
export default FormDataviewHeader;
